// extracted by mini-css-extract-plugin
module.exports =  {"fullname":"nHbwGc2","email":"XBThFIv"};